module.exports = __webpack_public_path__ + "media/3tentative.ca58b565.mp3";